<!-- form panel -->
<div class="card">
  <div class="card-header d-flex align-tems-center justify-content-between">
    <div>
      <button class="btn btn-light btn-sm" (click)="expanded = !expanded">
        @if (expanded) {
          <span class="dripicons-chevron-up"></span>
        }
        @if (!expanded) {
          <span class="dripicons-chevron-down"></span>
        }
      </button>

      {{ words[language][ 'communications' ] }} <span class="badge badge-light">{{(communicationsList && (communicationsList.length > 0)) ? communicationsList.length : ''}}</span>
    </div>

    @if (contactId) {
      <button (click)="cleanFields()" title="Add Communication" data-toggle="modal" data-target="#addCommunicationModal" title="Add" class="btn btn-sm btn-primary">
        <span class="uil-plus"></span>
      </button>
    }
  </div>
<!-- </div> -->
@if (expanded) {
  <div>
    <div class="card-body" [ngClass]="{'d-none': communicationsList.length == 0 }">
      <div class="row text-dark">
        @for (communication of communicationsList; track communication; let i = $index) {
          <div class="col-md-3 col-sm-12">
            <div class="card ribbon-box border">
              @if (communication.primary) {
                <div class="ribbon-two ribbon-two-primary">
                  <span>{{ words[language][ 'default' ] }}</span>
                </div>
              }
              <div class="card-header text-center text-capitalize">
                {{communication.subtype ? communication.subtype : communication.type}} <br>
                Department: {{filterForDepartment(communication.departmentId)}}
              </div>
              <div class="card-body">
                @if (communication.type=='phone') {
                  <p><a href="tel:{{communication.value}}">{{communication.value | phone}}</a></p>
                }
                @if (communication.type=='email') {
                  <p><a href="mailto:{{communication.value}}">{{communication.value}}</a>
                </p>
              }
              @if (communication.type=='facebook') {
                <p><a href="https://www.facebook.com/{{communication.value}}" target='_blank'>{{communication.value}}</a></p>
              }
              @if (communication.type=='website') {
                <p><a target="_blank" href="https://{{communication.value}}">{{communication.value}}</a>
              </p>
            }
          </div>
          <div class="card-footer text-center">
            @if (communication.primary) {
              <button class="btn btn-sm text-dark" name="'communication_'+{{communication.id}}"
                id="'communication_'+{{communication.id}}"
              (click)="selectDefault(communication)">Set as Default</button>
            }
            <!-- edit -->
            <button class="btn btn-sm text-dark"
              data-toggle="modal" title="Edit" data-target="#updateCommunicationModal"
              (click)="getCommunication(communication.id)">Edit
            </button>
            <!-- delete -->
            <button class="btn btn-sm text-danger"
              data-toggle="modal" title="Delete" data-target="#deleteCommunicationModal"
              (click)="selectCommunication(communication.id)">Delete
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
</div>
}
</div>

<!-- ?: modals -->
<div id="addCommunicationModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'addCommunication' ] }}</h4>
        <button type="button" class="close" data-dismiss="modal"
        id="close-modal-communications">×</button>
      </div>
      <div class="modal-body">
        <form [formGroup]="form">
          <ng-container formArrayName="methods">
            @for (methodForm of methods.controls; track methodForm; let i = $index) {
              <div>
                <div class="row mx-0" [formGroup]="methodForm">
                  <!-- type select-->
                  <div class="form-group col-md-3 col-sm-12">
                    <label for="firstName">{{ words[language][ 'type' ] }}</label>
                    <select class="custom-select mb-1 text-capitalize" formControlName="type"
                      (change)="clearSubTypeForm(i)">
                      @for (type of types; track type) {
                        <option [value]="type" class="text-capitalize">{{
                        type }}</option>
                      }
                    </select>
                  </div>
                  <!-- value input -->
                  <div class="form-group col-md-3 col-sm-12">
                    <label for="Value">{{ words[language][ 'value' ] }}</label>
                    <input class="form-control" type="text" formControlName="value"
                      autocomplete="address-level1" [email]="methodForm.get('type').value=='email'"
                      [minlength]="methodForm.get('type').value=='phone' ? 10 : 1">
                    @if (methodForm.get('value').invalid && methodForm.get('value').dirty) {
                      <span class="text-danger"
                        >{{
                      words[language][ 'invalidValue' ] }}</span>
                    }
                  </div>
                  <div class="form-group col-md-3 col-sm-12 m-0 px-0">
                    <label for="subtypes">Subtype</label>
                    <select class="custom-select custom-select text-capitalize"
                      formControlName="subtype">
                      @for (subtype of subtypes; track subtype) {
                        <option [value]="subtype"
                          class="text-capitalize"> {{subtype}}
                        </option>
                      }
                    </select>
                  </div>
                  <!-- type select-->
                  <div class="form-group col-md-3 col-sm-12">
                    <label for="update_department">{{ words[language][ 'departmentName' ] }}
                    </label>
                    <select class="custom-select mb-1 text-capitalize" id="update_department" formControlName="departmentId">
                      @for (department of departmentsList; track department) {
                        <option [value]="department.id"
                        class="text-capitalize">{{department.name}}</option>
                      }
                    </select>
                  </div>
                  <!-- icons -->
                  <div class="col-sm-1 d-flex align-items-center justify-content-center">
                    <!-- discard -->
                    @if ((methods.length > 1) && !loading) {
                      <span class="dripicons-trash text-danger clickable" (click)="discard(i)"
                      ></span>
                    }
                  </div>
                </div>
              </div>
            }
            <button type="button" class="btn btn-success btn-sm" (click)="add($event)" id="addMethod"><span
            class="dripicons-plus"></span> {{words[language].addAnother}}</button>
          </ng-container>

          <!--  -->
          <div class="col-md-12 d-flex justify-content-end px-3 mt-2">
            <!-- save button -->
            <button class="btn btn-success mr-2" id="btn-save-communications" (click)="save()"
              [disabled]="form.invalid || loading">
              @if (loading) {
                <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
              }
            {{ words[language][ 'save' ] }}</button>
            <!-- cancel button -->
            <button class="btn btn-light" id="btn-cancel-communications" data-dismiss="modal">{{
            words[language][ 'cancel' ] }}</button>
          </div>
        </form>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- ! delete modal -->
<div class="modal fade" id="deleteCommunicationModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
 >
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-cross text-danger h1"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deleteCommunication' ] }}</span>

        <button class="btn btn-danger mt-2" (click)="delete()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
          {{ words[language][ 'continue' ] }}
        </button>
        <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
          id="close-delete-modal-communications">{{ words[language][ 'cancel' ]
        }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- todo: update modals -->
<div id="updateCommunicationModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel"
 >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'updateCommunication' ] }}
        </h4>
        <button type="button" class="close" data-dismiss="modal">×</button>
      </div>
      <div class="modal-body">
        <form [formGroup]="modFormComms" class="d-flex p-2 justify-content-between row mx-0 w-100 ">
          <div class="form-group col-sm-12">
            <label for="update_type">{{ words[language][ 'type' ] }}</label>
            <select class="custom-select custom-select mb-1 text-capitalize" formControlName="type"
              (change)="clearSubTypeModFormComms(true,type.value)" id="update_type">
              @for (type of types; track type) {
                <option [value]="type" class="text-capitalize">{{ type }}
                </option>
              }
            </select>
          </div>
          <!-- value input -->
          <div class="form-group col-sm-12">
            <label for="update_value">{{ words[language][ 'value' ] }}</label>
            <input class="form-control" [type]="inputType" id="update_value" formControlName="value" [pattern]="inputPattern" [email]="type.value=='email'" [minlength]="type.value=='phone' ? 10 : 1" />
            @if (value.invalid && value.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidValue' ] }}</span>
            }
          </div>
          @if (type.value == 'phone') {
            <div class="form-group col-sm-12">
              <label for="subtypes">Subtype</label>
              <select class="custom-select custom-select text-capitalize" formControlName="subtype">
                @for (subtype of subtypes; track subtype) {
                  <option [value]="subtype" class="text-capitalize">
                    {{subtype}}
                  </option>
                }
              </select>
            </div>
          }
          <!-- type select-->
          <div class="form-group col-sm-12">
            <label for="update_department">{{ words[language][ 'departmentName' ] }}</label>
            <select class="custom-select custom-select mb-1 text-capitalize" formControlName="departmentId"
              id="update_department">
              @for (department of departmentsList; track department) {
                <option [value]="department.id">
                {{department.name}}</option>
              }
            </select>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <!-- save button -->
        <button class="btn btn-success mr-2" id="btn-save-communications"
          (click)="modifyCommunication(modFormComms.value)" [disabled]="modFormComms.invalid || loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
        {{ words[language][ 'save' ] }}</button>
        <!-- cancel button -->
        <button class="btn btn-light" id="btn-close-communications-update" data-dismiss="modal">{{
        words[language][ 'cancel' ] }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->